import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'


const Installation = ({ ...props }) =>
  <InstallationBlock>
    <Title>INSTALLATION IS A CLICK AWAY!</Title>
    <CarBenefits>
      <BenefitList>
        <BenefitIcon asset="purse" alt="" height={ 40 } width={ 40 } />
        <Item>Better For Your Wallet</Item>
      </BenefitList>
      <BenefitList>
        <BenefitIcon asset="car-icon" alt="" height={ 40 } width={ 40 } />
        <Item>Better For Your Car</Item>
      </BenefitList>
      <BenefitList>
        <BenefitIcon asset="petal" alt="" height={ 40 } width={ 40 } />
        <Item>Better For The Environment</Item>
      </BenefitList>
    </CarBenefits>
  </InstallationBlock>

export default Installation


const InstallationBlock = styled.div`
  width: 1280px;
  padding: 102px 105px;
  margin: 0 auto;
  background-position: right;
  background-size: cover;
  color: ${Theme.colors.blue};
`

const Title = styled.div`
  width: 440px;
  margin-bottom: 36px;
  ${Mixin.font.GothamBold(48)}
`

const CarBenefits = styled.div`
  font-size: 24px;
  font-weight: 400;
`

const BenefitList = styled.div`
  margin-bottom: 20px;
`

const Item = styled.div`
  display: inline-block;
  margin-left: 20px;
`

const BenefitIcon = styled(Icon)`
  display: inline-block;
`
